<template>
  <div class="navigation-buttons">
    <base-button
      class="navigation-buttons__button"
      :aria-label="$t('details.scroll-to-book-a-test-drive-section')"
      altcolor
      @click.native="moveTo(testDriveId)"
    >
      {{ $t("details.book-a-test-drive") }}
    </base-button>
    <base-button
      class="navigation-buttons__button"
      :aria-label="$t('details.scroll-to-apply-for-finance-section')"
      @click.native="moveTo(financeId)"
    >
      {{ $t("details.apply-for-finance") }}
    </base-button>
  </div>
</template>

<script>
import BaseButton from "@/components/ui/BaseButton/BaseButton.vue";
import { moveTo } from "@/utils";

export default {
  name: "DetailsNavigationButtons",
  components: {
    BaseButton
  },
  props: {
    testDriveId: {
      type: String,
      required: true
    },
    financeId: {
      type: String,
      required: true
    }
  },
  methods: {
    moveTo(elem) {
      return moveTo(elem);
    }
  }
};
</script>

<style lang="scss" scoped>
.navigation-buttons {
  padding: 5px 0 30px;
  border-bottom: 1px solid $color-grey-100;

  &__button {
    display: block;
    margin-top: 10px;
  }
}

@media screen and (min-width: $media-l) {
  .navigation-buttons {
    border-bottom: 0;
    padding-bottom: 0;
  }
}
</style>
